<template>
    <v-flex class="white_background">
        <v-layout column wrap :class="['member-directory-page', routeConfigHideHeader && 'no-header-layout']">
            <v-flex xs12 class="member-directory-page__title">{{memberDirectoryPageConstant.label.MEMBER_DIRECTORY_TITLE}}
              <div v-if="!routeConfigEngagementApp" class="pl-2 advanced-search" @click="openAdvancedSearchPage">
                <span class="label-gold"> {{memberDirectoryPageConstant.label.NEW}} </span>
                <small class="pl-1">{{memberDirectoryPageConstant.label.ADVANCED_SEARCH}}</small>
              </div>
            </v-flex>
            <v-flex xs12>
                <member-directory
                        :persisting-filter-key="appConstant.storageKeys.memberDirectoryStoredFilters">
                </member-directory>
            </v-flex>
            <back-to-top :bottom="'20px'" :right="'5px'"></back-to-top>
        </v-layout>
    </v-flex>
</template>

<script>
    import MemberDirectory from "./MemberDirectory";
    import { memberDirectoryPageConstant } from "./memberDirectoryPage.constants";
    import BackToTop from '../Layout/BackToTop.vue';
    import { appConstant } from "@/app.constant";
    import { mapGetters } from "vuex";
    import { storeGetters } from "@/store/storeGetters.constant";
    import { trackPageLoadTime } from '../../common/utils/performance';

    export default {
        name: 'MemberDirectoryPage',
        components: {
            MemberDirectory,
            BackToTop,
        },
        data() {
            return {
                appConstant,
                memberDirectoryPageConstant,
            };
        },
        mounted() {
            this.$nextTick(() => {
                trackPageLoadTime('MemberDirectoryPage');
            });
        },
        methods: {
          openAdvancedSearchPage() {
            const redirectUrl = `${process.env.VUE_APP_SALESFORCE_URL_ROOT}${memberDirectoryPageConstant.label.MEMBERDIRECTORY}`;
            const appOrigin = window.location.origin;
            window.open(redirectUrl, "_self");
            if (redirectUrl.includes(appOrigin) || (this.isMobileAppBrowser)) {
              window.open(redirectUrl, "_self");
            } else {
              window.open(redirectUrl, "_self");
            }
          },
        },
      computed: {
        ...mapGetters({
          isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
          routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
          routeConfigEngagementApp: `${[storeGetters.routeConfigEngagementApp]}`,
        }),
      },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .member-directory-page {
        position: relative;
        margin-top: 64px;
        padding: 0 80px;


        @include breakpoint(md) {
            padding: 0 45px;
        }

        @include breakpoint(xs) {
            padding: 0 5px;
        }

        &__title {
            background-color: $white;
            color: $ypo-blue;
            font-family: 'Raleway', sans-serif;
            font-size: 30px;
            font-weight: 500;
            padding: 20px 10px 0 0;
            display: flex;
            
            &--sub {
                @include breakpoint(xs) {
                    padding: 0 15px;
                }
            }
        }
        .label-gold {
          background: $ypo_gold;
          cursor: default;
          color: $white;
          font-size: 10px;
          padding: 3px 5px;
          line-height: 12px;
          font-weight: 500;
          text-transform: uppercase;
          border-radius: 6px;
        }
        .advanced-search{
          color: $ypo-cta;
          font-family: 'Raleway', sans-serif;
          font-weight: 600;
          cursor: pointer;
          @include breakpointMin(xs) {
            font-size: 12px;
            padding-top: 5px;
          }
          @include breakpointMin(sm) {
            padding-top: 12px;
            font-size: 16px;
          }
        }


    @media (max-width: 767px) {
            margin-top: 55px;

          &__title {
                font-size: 18px;
                padding: 10px 15px 0 15px;
            }

        }
    }
</style>
